export const USER_TYPES = {
  MINING_PRODUCER: 'miningProducer',
  BUYER_MINERALS: 'buyerMinerals',
  PROGRAM_ASSESSOR: 'programmAssessor',
  PROGRAM_PARTNER: 'programPartner',
}

export const useUserTypes = () => {
  return [
    { label: 'Artisanal mineral producer', value: USER_TYPES.MINING_PRODUCER },
    { label: 'Buyer of minerals', value: USER_TYPES.BUYER_MINERALS },
    { label: 'Program assessor', value: USER_TYPES.PROGRAM_ASSESSOR },
    { label: 'Program partner', value: USER_TYPES.PROGRAM_PARTNER },
  ]
}
